export const UPDATE_TERM_LIFE_INVESTMENT_BENEFIT = 'UPDATE_TERM_LIFE_INVESTMENT_BENEFIT'
export const updateTermLifeInvestmentBenefit = (investmentBenefit) => ({
  type: UPDATE_TERM_LIFE_INVESTMENT_BENEFIT,
  payload: investmentBenefit,
})
